module.exports = __webpack_public_path__ + "static/img/ent-detail-36.9f51359.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-36.jpg
// module id = Mjyc
// module chunks = 51